/* The oversized collection index selects products; Shopify renders their current
   prices, availability, linked colours, samples and wishlist controls. */
class V2IndexCards extends HTMLElement {
  connectedCallback() {
    this.cache = new Map();
    this.active = 0;
    this.controller = new AbortController();
    this.observer = new MutationObserver(() => this.fill());
    this.observer.observe(this, { childList: true, subtree: true });
    this.fill();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }
  fill() {
    for (const slot of this.querySelectorAll('[data-v2-index-card]:not([data-requested])')) {
      if (this.active >= 4) break;
      if (slot.dataset.requested) continue;
      slot.dataset.requested = 'true';
      this.load(slot);
    }
  }
  async load(slot) {
    this.active++;
    try {
      const url = new URL(slot.dataset.productUrl, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product');
      url.searchParams.set('section_id', 'v2-catalogue-index-card');
      let html = this.cache.get(url.href);
      if (!html) {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Product unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = page.querySelector('[data-v2-index-card-fragment] .ProductCard--catalogue');
        if (!card) throw new Error('Product unavailable');
        html = card.outerHTML;
        this.cache.set(url.href, html);
      }
      if (!slot.isConnected || this.controller.signal.aborted) return;
      slot.innerHTML = html;
      slot.removeAttribute('data-v2-index-card');
      this.inserted = true;
    } catch (error) {
      if (error.name === 'AbortError' || !slot.isConnected) return;
      // Keep the canonical product handoff. Never substitute an outdated price.
      const status = slot.querySelector('[role="status"]');
      if (status) status.textContent = 'View product for current details';
    } finally {
      this.active--;
      if (this.isConnected && !this.controller.signal.aborted) this.fill();
      if (this.isConnected && !this.controller.signal.aborted && this.active === 0 && this.inserted) {
        this.inserted = false;
        document.dispatchEvent(new CustomEvent('repubblica:sample_cards_loaded'));
      }
    }
  }
}
if (!customElements.get('v2-index-cards')) customElements.define('v2-index-cards', V2IndexCards);
